import { ProfileSchema, type Profile } from '@endcopilot/shared';

const PROFILE_LABEL: Record<Profile, string> = {
  MONITORING: 'Monitoramento',
  ASSISTED: 'Controle Assistido',
  CORPORATE: 'Controle Corporativo',
};

export function App() {
  return (
    <main className="mx-auto max-w-3xl px-4 py-10">
      <h1 className="text-2xl font-semibold">EndCopilot</h1>
      <p className="mt-2 text-slate-600">Painel de gerenciamento — ambiente em construção.</p>
      <ul aria-label="Perfis suportados" className="mt-6 grid gap-2 sm:grid-cols-3">
        {ProfileSchema.options.map((p) => (
          <li key={p} className="rounded-lg border border-slate-200 bg-white p-3 text-sm">
            {PROFILE_LABEL[p]}
          </li>
        ))}
      </ul>
    </main>
  );
}
